import { apiClient, handleApiRequest } from './client'
import type { AutoReRequestSchedule, AutoReRequestHistoryItem } from '@/types/admin5'

export interface SchedulesListResponse {
  schedules: AutoReRequestSchedule[]
  total?: number
}

export interface HistoryListResponse {
  lesson_request_id: string
  request_id: string
  total_re_requests: number
  history: AutoReRequestHistoryItem[]
  summary: {
    total_re_requests: number
    total_teachers_contacted: number
    total_responses: number
    total_acceptances: number
    total_declines: number
    success_rate: number
  }
}

export const autoReRequestApi = {
  listSchedules: (params?: { request_id?: string; status?: string; include_past?: boolean }) => {
    const qs = new URLSearchParams()
    if (params?.request_id) qs.set('request_id', params.request_id)
    if (params?.status) qs.set('status', params.status)
    if (params?.include_past) qs.set('include_past', 'true')
    const query = qs.toString()
    return handleApiRequest<SchedulesListResponse>(
      apiClient.get(`/api/v1/auto-re-request/schedules${query ? `?${query}` : ''}`),
    )
  },

  triggerNow: (
    lessonRequestId: string,
    opts?: { contact_same_teachers?: boolean; exclude_previous_decliners?: boolean; wave_size?: number; reason?: string },
  ) =>
    handleApiRequest(
      apiClient.post(`/api/v1/auto-re-request/lessons/${lessonRequestId}/trigger`, {
        delay_hours: 0,
        contact_same_teachers: opts?.contact_same_teachers ?? true,
        exclude_previous_decliners: opts?.exclude_previous_decliners ?? false,
        wave_size: opts?.wave_size ?? 15,
        reason: opts?.reason,
      }),
    ),

  cancelSchedule: (scheduleId: string, reason?: string) =>
    handleApiRequest(
      apiClient.delete(`/api/v1/auto-re-request/schedules/${scheduleId}`, {
        data: { cancellation_reason: reason },
      }),
    ),

  getHistory: (lessonRequestId: string, limit = 20) =>
    handleApiRequest<HistoryListResponse>(
      apiClient.get(`/api/v1/auto-re-request/lessons/${lessonRequestId}/history?limit=${limit}`),
    ),
}
